<template>
  <div class="forget-password">
    <div class="forget-password-form">
      <div v-if="type=='1'" class="title">修改密码</div>
      <div v-else class="title">忘记密码</div>
      <div class="input-group input-phone">
        <input class="mint-field-core form-input" v-model="phone" type="number" placeholder="请输入手机号">
        <div class="phone-code" :class="{'wait-send': waitSend}" @click="sendCode()">{{sendButtonText}}</div>
      </div>
      <div class="input-group">
        <input class="mint-field-core form-input" type="number" v-model="code" placeholder="请输入验证码">
      </div>
      <div class="input-group">
        <input class="mint-field-core form-input" type="password" v-model="password" placeholder="请输入密码 6-20位的数字和字母组合">
      </div>
      <div class="input-group">
        <input class="mint-field-core form-input" type="password" v-model="repeatPassword" placeholder="请确认密码">
      </div>
      <div class="form-btn" @click="modifyPassword">确认</div>
    </div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import customerUserService from '../service/customer/UserService'
  import codeService from '../service/phoneCode/CodeService'

  export default {
    name: 'RegisterStepOne',
    data () {
      return {
        phone: '',
        code:'',
        password:'',
        repeatPassword:'',
        sendStatus: false,
        sendTime: 60,
        sendButtonText: '获取验证码',
        waitSend:false,
        type:''
      }
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.type = this.$route.query.type;
    },
    methods: {
      checkPhone(){
        let phone = this.phone;
        if (phone == '') {
          Toast('请输入手机号码！');
          return false;
        }
        let re= /^1[3578]\d{9}$/;
        if(re.test(phone)){
          return true;
        } else {
          Toast('请输入11位手机号码！');
          return false;
        }
      },
      async checkRegister(){
        let {code,msg} = await customerUserService.checkRegister(this.phone,'1');
        if(code == '0'){
          return true;
        }else {
          Toast(msg);
          return false;
        }
      },
      async sendCode(){//发送验证码
        if(!this.checkPhone()){
          return;
        }
        if(!this.checkRegister()){
          return;
        }
        let phone = this.phone;
        this.sendStatus = true;
        let result = await codeService.sendPhoneCode(phone,1);
        if(result.code == '0'){
          Toast('验证码已发送至您的手机,请注意查收！');
          this.sendTime = 60;
          this.computeSendTime();
        }else {
          Toast('获取验证码失败');
        }
      },
      computeSendTime () {
        if (this.sendStatus) {
          if (this.sendTime == 0) {
            this.waitSend = false;
            this.sendStatus = false;
            this.sendButtonText = '重新获取'
          } else {
            this.waitSend = true;
            this.sendTime = this.sendTime - 1;
            this.sendButtonText = this.sendTime + '秒';
            setTimeout(() => {
              this.computeSendTime()
            }, 1000)
          }
        }
      },
      async modifyPassword(){
        if (!this.checkPhone()) {
          return;
        }
        if (!this.checkRegister()) {
          return;
        }
        let password = this.password;
        let repeatPassword = this.repeatPassword;
        if (password.length == 0) {
          Toast('请输入密码！');
          return false;
        }

        if(!/^([a-zA-Z0-9]|\w|[_!@#$&~|,，/.。?/？]){6,20}$/.test(password)){
          Toast('请正确填写密码');
          return;
        }
        if(repeatPassword.length<6){
          Toast('请再次填写密码');
          return;
        }
        if(password != repeatPassword){
          Toast('两次密码填写不一致');
          return;
        }
        if (this.code == null || this.code == '') {
          Toast('请填写验证码！');
        } else {
          let result = await codeService.checkPhoneCode(this.code, '1',this.phone);
          if (result.code == '0') {
            let res = await customerUserService.modifyPassword(this.phone, password);
            if (res.code == '0') {
              if(this.type == '1'){
                 Toast('修改密码成功!');
                 this.$router.go(-1);
              } else {
                Toast('找回密码成功!');
                this.$router.replace('/login');
              }
              Toast('找回密码成功!');
              this.$router.replace('/login');
            }else {
              Toast('找回密码失败，请稍后重试!');
            }
          }
        }
      }
    }
  }
</script>
<style lang="scss">
  .forget-password{
    width: 7.5rem;
    height: 11.8rem;
    font-size: 0.36rem;
    color: #878e99;
    margin-top: -1rem;
    display: flex;
    background: white url("../assets/icon-login-bg.png") no-repeat;
    background-position: center;
    background-size: cover;
    input{
      height: 0.4rem;
    }
    .forget-password-form{
      width: 6.9rem;
      margin: 1.2rem auto;
      background-color: white;
      border-radius: 0.1rem;
      box-shadow: 0rem 0.02rem 0.07rem 0rem rgba(0, 0, 0, 0.1);
      .title{
        height: 1.2rem;
        line-height: 1.2rem;
        margin-left: 0.3rem;
        color: #191818;
        font-weight: bold;
      }
    }
    .input-group{
      height: 0.9rem;
      width: 6.54rem;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      position: relative;
      font-size: 0.32rem;
      color: #191818;
      margin: 0rem auto 0.28rem;
      border-bottom: solid 1px #e0dedc;
    }
    .phone-code {
      width: 2.2rem;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 0.06rem;
      color: #feac00;
    }
    .input-group .input-label{
      width: 0.28rem;
      height: 0.42rem;
      padding-left:0.34rem;
      padding-right:.15rem;
      flex-grow: 0;
      flex-shrink: 0;
    }
    .input-label .icon-img{
      width: 100%;
      height: 100%;
    }
    .input-group .form-input{
      border: none;
      width: 4.5rem;
      padding-left: .2rem;
      flex-grow: 1;
      outline: none;
      height: 0.78rem;
      font-size: 0.32rem;
      line-height: 0.78rem;
    }
    .input-phone{
      margin-top: 0.3rem;
    }
    .form-btn{
      width: 2.8rem;
      height: 0.9rem;
      margin: 0.94rem auto 0.94rem auto;
      color: white;
      line-height: 0.9rem;
      text-align: center;
      border-radius: 0.45rem;
      background: #feac00;
    }

    *::-webkit-input-placeholder { /* WebKit browsers*/
      color:#cecbca!important;
      font-size:.32rem!important;
      padding-top:0.02rem;
    }
    *:-moz-placeholder {  /* Mozilla Firefox 4 to 18*/
      color:#cecbca!important;
      font-size:.32rem!important;
      padding-top:0.02rem;
    }
    *::-moz-placeholder {  /* Mozilla Firefox 19+*/
      color:#cecbca!important;
      font-size:.32rem!important;
      padding-top:0.02rem;
    }
    *:-ms-input-placeholder { /* Internet Explorer 10+*/
      color:#cecbca!important;
      font-size:.32rem!important;
      padding-top:0.02rem;
    }
  }

</style>
